import React from 'react';

import { RentVsBuyInput } from '../../../../../lib/utils';
import AnnualReturnCashInput from '../annual-return-cash';

const AnnualReturnCashInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  label,
  tooltip,
  className,
  fullWidth,
}) => {
  return (
    <AnnualReturnCashInput
      label={label}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

export default AnnualReturnCashInputWithAnalytics;
